"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = require("satcheljs/lib/legacy");
var Store_1 = require("../store/Store");
exports.showFilterDropDownContextMenu = legacy_1.action('showFilterDropDownContextMenu')(function () {
    Store_1.getStore().filterContextMenuDisplayState = true;
});
exports.hideFilterDropDownContextMenu = legacy_1.action('hideFilterDropDownContextMenu')(function () {
    Store_1.getStore().filterContextMenuDisplayState = false;
});
//# sourceMappingURL=filterContextMenuAction.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-list-filter-store/lib/actions/filterContextMenuAction.js
// module id = 2327
// module chunks = 46 105